import '../../../../../../../Avency.Sprehe.Base/Resources/Private/Assets/JavaScript/Project/globals';

(function(window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        const careerTeaserFilterItems = document.querySelectorAll('.career-teaser-filter-item');

        Array.from(careerTeaserFilterItems).forEach((careerTeaserFilterItem) => {
            careerTeaserFilterItem.addEventListener('click', () => {
                const active = careerTeaserFilterItem.dataset.filterActive === "1";

                const inputs = careerTeaserFilterItem.querySelectorAll('input');
                Array.from(inputs).forEach((input) => {
                    input.checked = !active;
                });

                careerTeaserFilterItem.dataset.filterActive = active ? "0" : "1";
            }, {passive: true});
        });
    });
})(window, document, window.PageLoadedQueue);
